import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard, SportGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// GAMES
const IndexPage = lazy(() => import('src/pages/dashboard/app'));
const GamePage = lazy(() => import('src/pages/dashboard/casino'));
// ----------------------------------------------------------------------

export const gamesRoutes = [
  {
    path: '',
    element: (
      <SportGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </SportGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      {
        path: 'game/:gameId',
        element: (
          <AuthGuard>
            <GamePage />
          </AuthGuard>
        ),
      },
    ],
  },
];
